var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import Moment from 'moment-timezone';
import _ from 'lodash';
import classNames from 'classnames';
import { GameTypeMap, GameFrequencyMap, DATE_FORMAT, TrackableModes } from 'constants/AdminConstants';
import { PRODUCT } from 'constants/LanguageConstants';
import { timeRemainingPercentageFromGame, getGameTypeFrequencyLabel, timeRemainingStringFromGame } from 'utils/GamesUtils';
import CompanyStore from 'stores/CompanyStore/store';
import TimerBar from './TimerBar';
var GameCard = /** @class */ (function (_super) {
    __extends(GameCard, _super);
    function GameCard(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.interval = null;
        var currentUser = CompanyStore.getCurrentUser();
        _this.state = __assign(__assign({}, _this.getRemaining()), { open: false, trackables: _this.sortTrackables(props), account_id: (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.account_id) !== null && _a !== void 0 ? _a : undefined });
        _this.toggleOpen = _this.toggleOpen.bind(_this);
        return _this;
    }
    GameCard.prototype.componentDidMount = function () {
        var _this = this;
        this.interval = setInterval(function () {
            _this.setRemaining.call(_this);
        }, 1000);
    };
    GameCard.prototype.UNSAFE_componentWillReceiveProps = function (props) {
        this.setState({
            trackables: this.sortTrackables(props)
        });
    };
    GameCard.prototype.componentWillUnmount = function () {
        if (this.interval) {
            clearInterval(this.interval);
        }
    };
    GameCard.prototype.getRemaining = function () {
        return {
            time_remaining_percentage: timeRemainingPercentageFromGame(this.props.game.settings, this.props.timezone),
            time_remaining_string: timeRemainingStringFromGame(this.props.game.settings, this.props.timezone)
        };
    };
    GameCard.prototype.getDateBlocks = function () {
        var _a;
        var start;
        var end;
        var minute;
        var ampm;
        if (parseInt(String(this.props.game.settings.frequency), 10) === GameFrequencyMap.DAILY) {
            // Start time
            start = parseInt(String(this.props.game.settings.start_hour), 10);
            minute = parseInt(String(this.props.game.settings.start_minute), 10);
            ampm = 'AM';
            if (start >= 12) {
                ampm = 'PM';
                if (start > 12) {
                    start -= 12;
                }
            }
            if (start === 0) {
                start = 12;
            }
            if (minute < 10) {
                minute = "0".concat(minute);
            }
            start = "".concat(start, ":").concat(minute, " ").concat(ampm);
            // End time
            end = parseInt(String(this.props.game.settings.end_hour), 10);
            minute = parseInt(String(this.props.game.settings.end_minute), 10);
            if (end)
                ampm = 'AM';
            if (end >= 12) {
                ampm = 'PM';
                if (end > 12) {
                    end -= 12;
                }
            }
            if (end === 0) {
                end = 12;
            }
            if (minute < 10) {
                minute = "0".concat(minute);
            }
            end = "".concat(end, ":").concat(minute, " ").concat(ampm);
        }
        else {
            var gameTimezone = (_a = this.props.game.settings.timezone) !== null && _a !== void 0 ? _a : this.props.timezone;
            start = Moment.tz("".concat(this.props.game.settings.start_date, " ").concat(this.props.game.settings.start_hour), DATE_FORMAT, gameTimezone).format('M/D/YYYY');
            end = Moment.tz("".concat(this.props.game.settings.end_date, " ").concat(this.props.game.settings.end_hour), DATE_FORMAT, gameTimezone).format('M/D/YYYY');
        }
        return (_jsxs("div", { className: "sb-game-card--dates", children: [_jsxs("div", { className: "game-dates--line", children: [_jsx("span", { className: "game-dates--label", children: "Started:" }), _jsx("span", { className: "game-dates--date", children: start })] }), _jsxs("div", { className: "game-dates--line", children: [_jsx("span", { className: "game-dates--label", children: "Ends:" }), _jsx("span", { className: "game-dates--date", children: end })] })] }));
    };
    GameCard.prototype.getGameCardTable = function () {
        var result;
        if (parseInt(String(this.props.game.settings.game_type), 10) === GameTypeMap.CLASSIC) {
            result = this.getClassicGameCard();
        }
        else {
            result = this.getFreeForAllGameCard();
        }
        return result;
    };
    GameCard.prototype.getTrackableInfo = function (infoArray) {
        var _this = this;
        return _.find(infoArray, function (info) {
            return info.account_id === _this.state.account_id;
        }) || infoArray[0];
    };
    /**
     * Convert trackables into labels depending on if it is tacking quantity or value
     * @returns {jsx} - Title header with label for trackable
     */
    GameCard.prototype.getTrackableLabels = function () {
        function mapTrackableToLabels(trackable) {
            var trackInfo = this.getTrackableInfo(trackable.info);
            var name = trackInfo.name;
            if (parseInt(String(trackable.trackable_mode), 10) === TrackableModes.QUANTITY) {
                name += ' - Quantity';
            }
            else if (trackable.value_label) {
                name += " - ".concat(trackable.value_label);
            }
            else {
                name += ' - Value';
            }
            return (_jsx("th", { children: name }, "".concat(trackInfo.id, "-").concat(trackable.trackable_mode)));
        }
        return this.state.trackables.map(mapTrackableToLabels, this);
    };
    /**
     * Map game members to table rows
     * @return {jsx} - Table row for each member in game
     */
    GameCard.prototype.getFreeForAllMemberRows = function () {
        var members = this.props.game.members;
        function mapMembersToHtml(member) {
            var memberId = parseInt(String(member.id), 10);
            var accountId = parseInt(String(member.account_id), 10);
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var self = this;
            function mapTrackableToScore(trackable) {
                var trackableInfo = self.getTrackableInfo(trackable.info);
                var trackableId = parseInt(String(trackableInfo.id), 10);
                var trackActivity = _.find(trackable.activity, function (activity) {
                    return parseInt(String(activity.member_id), 10) === memberId &&
                        parseInt(String(activity.account_id), 10) === accountId;
                });
                var trackMode = parseInt(String(trackable.trackable_mode), 10);
                var amountOrValue = trackMode === TrackableModes.QUANTITY ?
                    'total_amount' :
                    'total_value';
                var score = (amountOrValue === 'total_amount') ? 0 : '$0';
                if (trackActivity) {
                    if (amountOrValue === 'total_amount') {
                        score = trackActivity.total_amount;
                    }
                    else {
                        score = "$".concat(trackActivity.total_value);
                    }
                }
                return (_jsx("td", { children: score }, "".concat(trackableId, "-").concat(trackable.trackable_mode)));
            }
            var scores = self.state.trackables.map(mapTrackableToScore);
            return (_jsxs("tr", { children: [_jsx("td", { children: member.name }), scores] }, "".concat(member.account_id, ".").concat(memberId)));
        }
        return (members || []).map(mapMembersToHtml, this);
    };
    /**
     * Convert trackables on free for all games into cards to be rendered
     */
    GameCard.prototype.getFreeForAllGameCard = function () {
        var labels = this.getTrackableLabels();
        var rows = this.getFreeForAllMemberRows();
        var bodyClass = classNames({
            'sb-game-card-body': true,
            show: this.state.open
        });
        return (_jsx("div", { className: bodyClass, children: _jsx("div", { className: "table-scroll", children: _jsxs("table", { className: "sb-game-card-table table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", {}), labels] }) }), _jsx("tbody", { children: rows })] }) }) }));
    };
    GameCard.prototype.getClassicGameCard = function () {
        var ProductRows = [];
        function mapTrackableToHtml(trackable, index) {
            var actual = trackable.actual || 0;
            var goal = trackable.goal;
            var name = trackable.info[0].name;
            _.each(trackable.activity, function (activity) {
                if (parseInt(String(trackable.trackable_mode), 10) === TrackableModes.QUANTITY) {
                    actual = actual + parseInt(String(activity.total_amount), 10);
                }
                else {
                    actual = actual + parseInt(String(activity.total_value), 10);
                }
            });
            if (parseInt(String(trackable.trackable_mode), 10) === TrackableModes.QUANTITY) {
                name += ' - Quantity';
            }
            else {
                actual = "$".concat(actual);
                goal = "$".concat(goal);
                if (trackable.value_label) {
                    name += " - ".concat(trackable.value_label);
                }
                else {
                    name += ' - Value';
                }
            }
            return (_jsxs("tr", { children: [_jsx("td", { className: "cell-unit-8", children: name }), _jsx("td", { className: "cell-unit-2", children: actual }), _jsx("td", { className: "cell-unit-2", children: goal })] }, index));
        }
        ProductRows = this.props.game.trackables.map(mapTrackableToHtml);
        var bodyClasses = classNames({
            'sb-game-card-body': true,
            show: this.state.open
        });
        return (_jsx("div", { className: bodyClasses, children: _jsx("div", { className: "table-scroll", children: _jsxs("table", { className: "sb-game-card-table table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: PRODUCT }), _jsx("th", { children: "Score" }), _jsx("th", { children: "Goal" })] }) }), _jsx("tbody", { children: ProductRows })] }) }) }));
    };
    GameCard.prototype.getBadge = function () {
        var result = '';
        var stateAccountId = parseInt(String(this.state.account_id), 10);
        var gameAccountId = parseInt(String(this.props.game.settings.account_id), 10);
        if (stateAccountId !== gameAccountId) {
            result = (_jsx("span", { className: "sb-game-card--special sbgcs-agency", children: "Cross Account" }));
        }
        return result;
    };
    GameCard.prototype.setRemaining = function () {
        this.setState(this.getRemaining());
    };
    GameCard.prototype.sortTrackables = function (props) {
        return _.sortBy(props.game.trackables, function (trackable) {
            return parseInt(String(trackable.order), 10);
        });
    };
    GameCard.prototype.toggleOpen = function () {
        this.setState(function (state) {
            return __assign(__assign({}, state), { open: !state.open });
        });
    };
    GameCard.prototype.render = function () {
        var _a, _b, _c;
        var dateBlocks = this.getDateBlocks();
        var frequency = (_a = this.props.game.settings.frequency) !== null && _a !== void 0 ? _a : 0;
        var numericFrequency = typeof frequency === 'string' ? parseInt(frequency, 10) : frequency;
        var gameType = getGameTypeFrequencyLabel((_b = this.props.game.settings.member_type) !== null && _b !== void 0 ? _b : '', (_c = this.props.game.settings.game_type) !== null && _c !== void 0 ? _c : '', numericFrequency);
        var gameCardTable = this.getGameCardTable();
        var containerClasses = classNames({
            'sb-game-card-container': true,
            'game-type--tracking': parseInt(String(this.props.game_type), 10) === GameTypeMap.CLASSIC,
            'game-type--competitive': parseInt(String(this.props.game_type), 10) === GameTypeMap.FREE_FOR_ALL,
            'cross-agency': parseInt(String(this.state.account_id), 10) !== parseInt(String(this.props.game.settings.account_id), 10)
        });
        var numProducts = 0;
        if (this.props.game.trackables &&
            this.props.game.trackables.length &&
            this.props.game.trackables.length >= 1 &&
            this.props.game.trackables.length <= 8) {
            numProducts = this.props.game.trackables.length;
        }
        var iconUrl = "/img/admin/scoreboard_icons/".concat(numProducts, ".png");
        var baseScoreboardLink = '/admin/scoreboard';
        var desktopScoreboardLink = "".concat(baseScoreboardLink, "/game/").concat(this.props.game.settings.id);
        var mobileScoreboardLink = "".concat(desktopScoreboardLink, "?scoreboard#");
        var scoreboardLink = this.props.mobileApp ? mobileScoreboardLink : desktopScoreboardLink;
        return (_jsxs("div", { className: containerClasses, onClick: this.toggleOpen, children: [_jsx(TimerBar, { time_remaining_percentage: this.state.time_remaining_percentage, time_remaining_string: this.state.time_remaining_string }), _jsxs("div", { className: "sb-game-card", children: [_jsxs("div", { className: "sb-game-card-header", children: [_jsx("img", { className: "sb-game-card--icon", src: iconUrl, alt: "" }), _jsxs("div", { className: "sb-game-card--game-info-block", children: [_jsxs("span", { className: "sb-game-card--type", children: [gameType, this.getBadge()] }), _jsx("span", { className: "sb-game-card--name", children: this.props.game.settings.name })] }), dateBlocks, _jsx("button", { className: "sb-game-card-expand", children: _jsx("i", { className: "icon--sm ion-arrow-down-b" }) })] }), gameCardTable] }), _jsx("footer", { className: "sb-game-card-footer", children: _jsxs("a", { className: "button--link button--sm", href: scoreboardLink, rel: "noreferrer", target: "_blank", children: [_jsx("i", { className: "icon--sm ion-ios-monitor" }), ' ', "View Scoreboard"] }) })] }));
    };
    return GameCard;
}(React.Component));
export default GameCard;
